import { useEffect, useState } from 'react';
import { Button } from './Button';
import type { ConfirmDialogOptions } from './feedback';

interface ActiveConfirm extends ConfirmDialogOptions {
  resolve: (confirmed: boolean) => void;
}

export const ConfirmDialogHost = () => {
  const [confirm, setConfirm] = useState<ActiveConfirm | null>(null);

  useEffect(() => {
    const handleConfirm = (event: Event) => {
      setConfirm((event as CustomEvent<ActiveConfirm>).detail);
    };

    window.addEventListener('app:confirm', handleConfirm);
    return () => window.removeEventListener('app:confirm', handleConfirm);
  }, []);

  if (!confirm) return null;

  const close = (confirmed: boolean) => {
    confirm.resolve(confirmed);
    setConfirm(null);
  };

  return (
    <div className="fixed inset-0 z-[60] grid content-center bg-text/70 p-5 backdrop-blur-sm">
      <div className="brand-panel w-full max-w-[420px] mx-auto p-6">
        <h2 className="mb-2 text-xl font-semibold text-text">
          {confirm.title || 'Please confirm'}
        </h2>
        <p className="mb-6 text-sm font-medium leading-6 text-muted">{confirm.message}</p>
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={() => close(false)}>
            {confirm.cancelLabel || 'Cancel'}
          </Button>
          <Button
            variant={confirm.variant === 'danger' ? 'danger' : 'primary'}
            onClick={() => close(true)}
          >
            {confirm.confirmLabel || 'Confirm'}
          </Button>
        </div>
      </div>
    </div>
  );
};
